import React, { PureComponent } from "react";
import Cookies from "universal-cookie";
import axios from "axios";
import { BrowserRouter as Router, Redirect } from "react-router-dom";
// import Header from "../header/Header";
import GameIndex from "../../routes/gameIndex/GameIndex";
import RoleAssignment from "../../routes/roleAssignment/RoleAssignment";
import { Provider } from "mobx-react";
import Store from "../../store";
import { FETCH_URL } from "../../constants/ServerLinks";
import { STUDENT_POLL_TIME } from "../../constants/Polling";

// ***DEV COMMENT -- STEVEN*** -- Changed pages to "game" to prevent authentication from routing to the landing or assign pages

export default class Authenticator extends PureComponent {
  constructor(props) {
    super(props);

    this.cookies = new Cookies();

    this.fetchURL = FETCH_URL;
    this.city_skey = this.cookies.get("city_skey");
    this.cityId = this.cookies.get("city_id");
    this.p_id = this.cookies.get("p_id");
    this.config_number = this.cookies.get("config_number");
    this.sector_id = this.cookies.get("sector_id");
    this.current_year = this.cookies.get("current_year");
    this.sName = this.cookies.get("s_name");
    this.city_config = this.cookies.get("city_config");
    this.student_is_manager = this.cookies.get("student_is_manager");
    this.student_role = this.cookies.get("student_role");
    this.student_team_name = this.cookies.get("student_team_name");
    this.store = this.cityId && new Store({}, this.cityId);

    this.state = { page: "", updateDrawer: true };

    this.polTime = STUDENT_POLL_TIME;
  }

  // Make sure city exists.  If it does, add City data to cookies and start the game, set cookies

  authenticateCity = () => {
    axios
      .post(this.fetchURL + "/api/v1/cities/authenticate/", {
        city_skey: this.city_skey,
      })
      .then((response) => {
        console.group("Authenticator:authenticateCity");
        console.log(response.data);

        if (response.data.success) {
          console.log("City Authentication Successful");

          const data = response.data.data;
          this.cookies.set("city_id", data.city_id, { maxAge: 86400 });
          this.cookies.set("city_config", data.city_config, { maxAge: 86400 });
          this.cookies.set("current_year", data.city_current_year, {
            maxAge: 86400,
          });
          sessionStorage.setItem("current_year", data.city_current_year + 1);
          sessionStorage.setItem("previous_year", data.city_current_year);
          this.setState({ page: "game" });
        } else {
          console.log("Invalid City Key!");
          this.setState({ page: "landing" });
          this.cookies.remove("p_id");
          this.cookies.remove("s_name");
          this.cookies.remove("city_id");
          this.cookies.remove("city_name");
          this.cookies.remove("city_skey");
          this.cookies.remove("config_number");
          this.cookies.remove("sector_id");
          this.cookies.remove("sector_name");
          this.cookies.remove("current_year");
          this.cookies.remove("city_config");
        }
        console.groupEnd();
      })
      .catch((error) => {
        this.setState({ page: "landing" });
        console.log("Error Thrown:  " + error.response);
      });
  };

  //When the component mounts, make sure the city has been authenticated, else, reset the page to login
  componentDidMount = () => {
    if (this.sName === undefined) {
      this.setState({
        page: "landing",
      });
    } else {
      this.authenticateCity();
    }
  };

  // sendToDecisions = () => {
  //     this.setState(() => ({
  //         std: new Date().getTime(),
  //     }));
  // };

  onCb = () => {
    this.setState(() => ({
      updateDrawer: true,
    }));
  };

  componentDidUpdate = () => {
    this.setState(() => ({
      updateDrawer: false,
    }));
  };

  render() {
    return (
      <div>
        {this.state.page === "game" ? (
          <Provider {...this.store}>
            <div>
              <Redirect to="/game/city" />
            </div>
          </Provider>
        ) : null}
        {this.state.page === "landing" ? (
          <div>
            <GameIndex display="show" />
          </div>
        ) : null}
        {this.state.page === "assign" ? (
          <div>
            <Router>
              <RoleAssignment />
            </Router>
          </div>
        ) : null}
      </div>
    );
  }
}
